/**
 * User Profile Complete Route - React Router v7
 *
 * Route: /user/profile/complete/purchase
 * Description: Complete user profile for purchase flow (no server-side data fetching)
 */
import type {LoaderFunctionArgs} from 'react-router-dom'
/* eslint-disable @typescript-eslint/restrict-template-expressions, @typescript-eslint/no-throw-literal, @typescript-eslint/strict-boolean-expressions, @typescript-eslint/prefer-nullish-coalescing, @typescript-eslint/no-unused-vars */
import {useLoaderData} from 'react-router-dom'

import UserProfileComplete from './index.js'

// Import styles
import './styles/index.scss'

/**
 * Loader for User Profile Complete page
 * This page has no server-side data fetching - data is fetched client-side on mount
 */
export async function loader(_args: LoaderFunctionArgs) {
  return {}
}

/**
 * Component wrapper
 * Uses existing UserProfileComplete component
 */
export function Component() {
  const data = useLoaderData()
  return <UserProfileComplete {...data} />
}

export default {loader, Component}
